//import 'ol/ol.css';
//import 'ol/ol.css';
import { Map, Feature } from 'ol';
import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult, TextPack} from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Shared/Utility/Utilities';

import * as events from '../Shared/Bus/Bus';
import { CustomFilter, CustomFilterField, CustomFilterOperator, CustomFilterType } from '../Shared/Models/CustomFilterModels';
import { IssueFilter, IssueOrder } from '../Shared/Maint/MaintModels';
import { PathFilter, PathOrder } from '../Shared/Path/PathModels';
import { IFilterDefinitionModel } from '../Shared/Models/FilteringModel';
import { RouteOrder } from '../Shared/Route/RouteModels';
import { InfraOrder } from '../Shared/Infra/InfraModels';
import { LandOrder } from '../Shared/Land/LandModels';
import { ReportModel, SystemType } from '../Reports/ReportsModels';
import { CustomFiltersHelper } from '../Shared/Utility/CustomFiltersHelper';
import * as AuthModel from '../Shared/Models/AuthModel';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';
import { Translations } from '../Shared/Models/StaticTranslations';

export class OfficerMapRecordList {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private customFilterEl: JQuery<HTMLElement>;
    private treeView: any;
    private treeData: Array<INode> = [];
    private issueMaxNumberInList: number = 10;
    private issueCountFromServer: number = 0;
    private currentPage: number = 0;
    private currentSortOrder;
    private currentSortDirection: OrderDirection;
    private customFilterHelper = new CustomFiltersHelper();
    private issueCustomFilterDefinitions: Array<CustomFilter> = [];
    private routeCustomFilterDefinitions: Array<CustomFilter> = [];
    private infraCustomFilterDefinitions: Array<CustomFilter> = [];
    private landCustomFilterDefinitions: Array<CustomFilter> = [];
    private pathCustomFilterDefinitions: Array<CustomFilter> = [];
    private RecordList_Label_Of: string;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults
    // List of buttions in the action toolbar
    private actionBtns = {
        viewprint: { btn: $('#recordListPrintBtn button'), enable: false },
        map: { btn: $('#recordListZoomToMapSelectedBtn button'), enable: false },
        export: { btn: $('#recordListExportSelectedBtn button'), enable: false },
        annotate: { btn: $('#recordListAnnotateBtn button'), enable: false },
        edit: { btn: $('#recordListEditBtn button'), enable: false },
        query: { btn: $('#recordListQueryBtn button'), enable: false },
        newTask: { btn: $('#recordListNewTaskBtn button'), enable: false }
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: Map, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Bind buttons
        $('#recordListCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));
        });
        $('#recordListTypeSelectOptions select').on('change', function () { self.recordListTypeSelected(); });
        $('#recordListPredefinedFiltersOptions select').on('change', function () { self.recordListPredefinedFiltersSelected(); });
        $('#recordListPageAmount select').on('change', function () { self.recordListPageAmountSelected(); });
        $('#recordListSelectAllBtn').on('change', function () { self.recordListSelectAllChecked(); });
        $('#recordListSearchBtn').on('click', function () {
            self.recordListTypeSelected();
            self.GetTreeData();
            $('#recordListPanel').css('width', '600px');

            this.blur();
        });

        // CUSTOM FILTERS
        $('#recordListShowCustomFilterBtn').on("click", function () {
            // Check if there are pcustom filters configured
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            $('#recordListCustomFilterContainer').addClass('show');
            $('#recordListShowCustomFilterBtn').addClass('text-success');
            self.customFilterHelper.customFilterAddRow(true);
            this.blur();
        });
        $('#recordListCustomFilterContainer [name="recordListCustomFilterAddBtn"]').on("click", function () {
            self.customFilterHelper.customFilterAddRow();
            this.blur();
        });
        $('#recordListCustomFilterContainer [name="recordListCustomFilterCloseBtn"]').on("click", function () {
            $('#recordListCustomFilterContainer').removeClass('show');
            $('#recordListShowCustomFilterBtn').removeClass('text-success');
            $('#recordListPredefinedFiltersOptions select').removeAttr("disabled");
      
            self.resetPage();
            self.recordListTypeSelected();
            $("#recordListPredefinedFiltersOptions select").prop("selectedIndex", 0);
            self.GetTreeData();
            this.blur();
        });
        $('#recordListCustomFilterContainer [name="recordListCustomFilterSearchBtn"]').on("click", function () {
            var i = self.getPredefinedFilterIndexOfCustomFilter();
            if (i == -1) {
                toastr.error("A pre-defined custom filter has been configured.");
                return;
            }

            // Disable the pre-defined filters and set to 'Custom Filter'
            $("#recordListPredefinedFiltersOptions select").prop("selectedIndex", i);
            $('#recordListPredefinedFiltersOptions select').attr("disabled", "disabled");

            // Reset the page
            self.currentPage = 0;
            self.issueCountFromServer = 0;
            self.currentSortDirection = null;
            self.currentSortOrder = null;
            self.updatePagingUI();

            self.GetTreeData();
            this.blur();
        });

        // RECORD LIST
        $('#recordListClearAllBtn').on("click", function () { self.DeleteAllNodes(); this.blur(); });
        $('#recordListExpandAllBtn').on('click', function () { self.ExpandAllNodes(); this.blur(); });
        $('#recordListCollapseAllBtn').on('click', function () { self.CollapseAllNodes(); this.blur(); });
        $('#recordListSelectAllBtn').on('click', function () { self.SelectAllNodes(); this.blur(); });
        $('#recordListUnSelectAllBtn').on('click', function () { self.UnSelectAllNodes(); this.blur(); });

        $('#recordListShowingStartBtn').on("click", function () {
            self.currentPage = 0;
            this.blur();
            self.GetTreeData();
        });
        $('#recordListShowingEndBtn').on("click", function () {
            self.currentPage = Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList);
            this.blur();
            self.GetTreeData();
        });
        $('#recordListShowingNextBtn').on("click", function () {
            if (self.currentPage == Math.trunc(self.issueCountFromServer / self.issueMaxNumberInList)) return;
            self.currentPage++;
            this.blur();
            self.GetTreeData();
        });
        $('#recordListShowingPrevBtn').on("click", function () {
            if (self.currentPage == 0) return;
            self.currentPage--;
            this.blur();
            self.GetTreeData();
        });

        // Action btns
        self.actionBtns.export.btn.on('click', function () { toastr.info('To be completed'); this.blur(); });
        self.actionBtns.map.btn.on("click", function () { self.ZoomToChecked(); this.blur(); });
        self.actionBtns.viewprint.btn.on('click', function () {
            // Setup variables
            let data: ReportModel = {};
            var values: Array<string> = [];
            let filterDef: IFilterDefinitionModel = $('#recordListPredefinedFiltersOptions select').children("option:selected").data('filterdefinition');

            // Get seleced nodes
            var nodes: Array<INode> = self.treeView.treeview('getSelected');
            if (nodes != null) {
                nodes = nodes.concat(self.treeView.treeview('getChecked')); // This makes sure we get all selected and checked nodes
                nodes.forEach(n => values.push(n.href));
            }

            // Get fdeature type
            let featureType = parseInt($('#recordListTypeSelectOptions select').children("option:selected").val() as any);
            if (featureType == FeatureType.Maint) {
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Maint_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Maint_Multi; }
            }
            else if (featureType == FeatureType.Infra) {
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Infra_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Infra_Multi; }
            }
            else if (featureType == FeatureType.Route) {
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Route_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Route_Multi; }
            }
            else if (featureType == FeatureType.Land) {
                if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Land_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Land_Multi; }
            }
            else if (featureType == FeatureType.Path) {
                 if (nodes.length == 1) { data.systemType = SystemType.OfficerMap_RecordList_Path_Single; }
                else { data.systemType = SystemType.OfficerMap_RecordList_Path_Multi; }
            }

            // Add custom filters
            var cf: Array<string> = [];
            var customFilters: Array<CustomFilter> = self.customFilterHelper.customFilterGetFilters();
            customFilters.forEach(c => {
                var str = JSON.stringify(c,
                    function replacer(key, value) {
                        // This will make sure the operator is returned as a number
                        // Important when the json is deserialized by the API
                        if (key === 'operator') {
                            return parseInt(value);
                        }
                        return value;
                    }
                );
                cf.push(str);
            });

            // If there is NO filterDef.viewName, then do not prompt the user 
            if (filterDef == null || filterDef.viewName == null) {
                var selectedMsg = "Selected Records Only (" + values.length + ")";
                data.reportParameters = [{ name: "codes", values: values }];
                events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
            }
            else if (values.length ==0) {
                var filterMsg = "Filter (" + filterDef.label + ")";
                data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                if (cf.length > 0) data.reportParameters.push({ name: "customFilters", values: cf });
                events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
            }
            else {
                var filterMsg = "Filter (" + filterDef.label + ")";
                var selectedMsg = "Selected Records Only (" + values.length + ")"; 

                var dataStr = [{ key: "AllLabel", value: filterDef.label }, { key: "FilterLabel", value: values.length }, { key: "YesBtn", value: values.length  }, { key: "NoBtn", value: filterDef.label }];
                ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.RecordListReport, data: dataStr }).then(r => {
                    if (r.yes == true) {
                        data.reportParameters = [{ name: "codes", values: values }];
                        events.bus.publish(events.eventOpenReportOrSelectList([data, selectedMsg]));
                    }
                    else {
                        data.reportParameters = [{ name: "filterViewName", values: [filterDef.viewName] }];
                        if (cf.length > 0) data.reportParameters.push({ name: "customFilters", values: cf });
                        events.bus.publish(events.eventOpenReportOrSelectList([data, filterMsg]));
                    }
                }).catch(e => { });

            }
            
        });

        self.actionBtns.annotate.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
            this.blur();
        });
        self.actionBtns.edit.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventOpenEditPanel(data));
            this.blur();
        });
        self.actionBtns.query.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: ICAMSKey = { code: nodes[0].href, featureType: nodes[0].featureType };
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
            this.blur();
        });
        self.actionBtns.newTask.btn.on('click', function () {
            var nodes: Array<INode> = self.treeView.treeview('getChecked');
            nodes = nodes.concat(self.treeView.treeview('getSelected'));
            let data: Array<ICAMSKey> = nodes.map(n => { return { code: n.href, featureType: n.featureType } });
            events.bus.publish(events.eventOpenTasksCreatePanel([data, function (r) {
                events.bus.publish(events.eventEntityUpdated(data[0]));
            }]));

            this.blur();
        });

        // Get the custom filter defnitions
        self.issueCustomFilterDefinitions = $('#recordListContainer [data-issuecustomfilterdefinitions]').data('issuecustomfilterdefinitions');
        self.routeCustomFilterDefinitions = $('#recordListContainer [data-routecustomfilterdefinitions]').data('routecustomfilterdefinitions');
        self.infraCustomFilterDefinitions = $('#recordListContainer [data-infracustomfilterdefinitions]').data('infracustomfilterdefinitions');
        self.landCustomFilterDefinitions = $('#recordListContainer [data-landcustomfilterdefinitions]').data('landcustomfilterdefinitions');
        self.pathCustomFilterDefinitions = $('#recordListContainer [data-pathcustomfilterdefinitions]').data('pathcustomfilterdefinitions');

        // Get the initial custom filter element for later on
        self.customFilterEl = $('#recordListCustomFilterContainer [name="recordListCustomFilterRow"]').clone(false);
        $('#recordListCustomFilterContainer [name="recordListCustomFilterRow"]').remove(); // Then remove it, it is added by the ADD button later on

        // Get translations used later on
        Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "RecordList_Label_Of" }]).then(m => {
            if (m.success == true) self.RecordList_Label_Of = m.data[0].value;
            else self.RecordList_Label_Of = "of";
        });
    }

    // ----------------------------------------------------------- //
    // OPEN PANEL
    public OpenRecordListPanel = (): void => {
        this.resetPage();

        $('#recordListPanel').css('width', '400px');
        $('#recordListPanel').addClass('show');
        $('#recordListSelectContainer').show();
        $('#recordListFilterContainer').hide();
        $('#recordListResultsContainer').hide();
        $('#recordListFooterContainer').hide();
        $('#recordListPanel').css('bottom', 'unset');
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTreeData = (): void => {
        const self = this;

        let featureType = parseInt($('#recordListTypeSelectOptions select').children("option:selected").val() as any);
        
        // Apply UI Custom filters
        var customFilters: Array<CustomFilter> = self.customFilterHelper.customFilterGetFilters();

        // Set the default filter to be all
        let filterVal = IssueFilter.All.toString();

        // Apply any filters selected from the drop down
        let viewName = "";
        let filterDef: IFilterDefinitionModel = $('#recordListPredefinedFiltersOptions select').children("option:selected").data('filterdefinition');
        if (filterDef != null) {
            viewName = filterDef.viewName;
            if (filterDef.issueFilter != null) filterVal = filterDef.issueFilter.toString();
        }

        let url = "";
        let countUrl = "";
        switch (featureType) {
            case FeatureType.Route:
                url = window.G_SITEFOLDERNAME+"/OfficerMap/GetTreeDataWithPredefinedFilter_Route";
                countUrl = window.G_SITEFOLDERNAME + "/OfficerMap/GetRouteCount_ByView";
                break;
            case FeatureType.Maint:
                url = window.G_SITEFOLDERNAME + "/OfficerMap/GetTreeDataWithPredefinedFilter_Issue";
                countUrl = window.G_SITEFOLDERNAME + "/OfficerMap/GetReportedIssuesCount_ByView";
                break;
            case FeatureType.Infra:
                url = window.G_SITEFOLDERNAME + "/OfficerMap/GetTreeDataWithPredefinedFilter_Infra";
                countUrl = window.G_SITEFOLDERNAME + "/OfficerMap/GetInfraCount_ByView";
                break;
            case FeatureType.Land:
                url = window.G_SITEFOLDERNAME + "/OfficerMap/GetTreeDataWithPredefinedFilter_Land";
                countUrl = window.G_SITEFOLDERNAME + "/OfficerMap/GetLandCount_ByView";
                break;
            case FeatureType.Path:
                url = window.G_SITEFOLDERNAME + "/OfficerMap/GetTreeDataWithPredefinedFilter_Path";
                countUrl = window.G_SITEFOLDERNAME + "/OfficerMap/GetPathCount_ByView";
                break;
        }

        // get the issue count
        self.getCount(countUrl, filterVal, customFilters, viewName, featureType);

        let query = { data: { ViewName: viewName, Filter: filterVal, CustomFilters: customFilters, Order: self.currentSortOrder, OrderDirection: self.currentSortDirection, Skip: self.currentPage * self.issueMaxNumberInList, Take: self.issueMaxNumberInList } };
        Utilities.BlockUI($('#recordListContainer'));

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        // Update tree
                        self.DeleteAllNodes();
                      
                        var data = result.data.nodes as Array<INode>;
                        self.addData_to_treeData(data);
                        self.createTree(self.treeData, true);
                        $('#recordListSelectContainer').hide();
                        $('#recordListFilterContainer').show();
                        $('#recordListResultsContainer').show();
                        $('#recordListFooterContainer').show();
                        $('#recordListPanel').css('bottom', '0px');

                        // Update UI
                        self.updatePagingUI();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    Utilities.UnBlockUI($('#recordListContainer'));
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
    
    private getCount = (url: string, issueFilter: string, customFilters: CustomFilter[], viewName: string, featureType: FeatureType): void => {
        // Get the data from the server
     
        const self = this;
        let query = { viewName: viewName, issueFilter: issueFilter, customFilters: customFilters };
        
        $.post(url, query, function (result: IAPIResult) {
            try {
                $('#totalRouteLength').html('');
                $('#recordCount').html("");
                if (result && result.success == true) {
                    self.issueCountFromServer = result.totalCount;
                    $('#recordCount').html(' (' + self.issueCountFromServer + ')');
                    if (result.data && (featureType == FeatureType.Route||featureType == FeatureType.Path)) {
                        $('#recordListRouteTotalLengthContainer').show();
                        if (result.data != null) $('#recordListRouteTotalLength').html(Utilities.NumberWithCommas(Math.round((result.data))));
                    } else $('#recordListRouteTotalLengthContainer').hide(); 
                }

            }
            catch (e) {
                console.log("Error getting issue data: getCount");
                console.log(e);
            }
        }).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // ON SELECT CHANGE
    private recordListTypeSelected = (): void => {
        const self = this;

        let featureType = parseInt($('#recordListTypeSelectOptions select').children("option:selected").val() as any);
        $('#recordListPredefinedFiltersOptions select').find('option').remove().end();
        
        // Populate filters and order
        var customFilterDefinitions;
        switch (featureType) {
            case FeatureType.Route:
                let routeRecordListFilters: Array<IFilterDefinitionModel> = $('#recordListPanel [data-routerecordlistfilters]').data('routerecordlistfilters');
                routeRecordListFilters.forEach(f => {
                    $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });

                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Links" }]).then(m => {
                    if (m.success == true) $('#recordListTitle').text(m.data[0].value);
                    else $('#recordListTitle').text("Links");
                });
               
                customFilterDefinitions = self.routeCustomFilterDefinitions;
                break;
            case FeatureType.Maint:
                // Add bespoke filter
                var labelStr = window.isSiteInWelsh() == 1 ? "Eithriadol - neilltuo i mi" : "Outstanding - assigned to me";
                var b: IFilterDefinitionModel = { label: labelStr, issueFilter: IssueFilter.OutstandingAssignedToCurrentUser };
                $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(b)).text(b.label));

                let maintRecordListFilters: Array<IFilterDefinitionModel> = $('#recordListPanel [data-maintrecordlistfilters]').data('maintrecordlistfilters');
                maintRecordListFilters.forEach(f => {
                    $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });

                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Issues" }]).then(m => {
                    if (m.success == true) $('#recordListTitle').text(m.data[0].value);
                    else $('#recordListTitle').text("Issues");
                });
                customFilterDefinitions = self.issueCustomFilterDefinitions;
                break;
            case FeatureType.Infra:
                let infraRecordListFilters: Array<IFilterDefinitionModel> = $('#recordListPanel [data-infrarecordlistfilters]').data('infrarecordlistfilters');
                infraRecordListFilters.forEach(f => {
                    $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });

                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Furniture" }]).then(m => {
                    if (m.success == true) $('#recordListTitle').text(m.data[0].value);
                    else $('#recordListTitle').text("Furniture");
                });
                customFilterDefinitions = self.infraCustomFilterDefinitions;
                break;
            case FeatureType.Land:
                let landRecordListFilters: Array<IFilterDefinitionModel> = $('#recordListPanel [data-landrecordlistfilters]').data('landrecordlistfilters');
                landRecordListFilters.forEach(f => {
                    $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });

                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Land" }]).then(m => {
                    if (m.success == true) $('#recordListTitle').text(m.data[0].value);
                    else $('#recordListTitle').text("Land");
                });
                customFilterDefinitions = self.landCustomFilterDefinitions;
                break;
            case FeatureType.Path:
                let pathRecordListFilters: Array<IFilterDefinitionModel> = $('#recordListPanel [data-pathrecordlistfilters]').data('pathrecordlistfilters');
                pathRecordListFilters.forEach(f => {
                    $('#recordListPredefinedFiltersOptions select').append($("<option></option>").attr("data-filterdefinition", JSON.stringify(f)).text(f.label));
                });

                Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "FeatureName_Path" }]).then(m => {
                    if (m.success == true) $('#recordListTitle').text(m.data[0].value);
                    else $('#recordListTitle').text("Path");
                });
                customFilterDefinitions = self.pathCustomFilterDefinitions;
                break;
        }

        // Reset the custom filters
        self.customFilterHelper.init($('#recordListCustomFilterContainer'), self.customFilterEl, customFilterDefinitions);
        $('#recordListCustomFilterContainer').removeClass('show');
        $('#recordListShowCustomFilterBtn').removeClass('text-success');

        function isNumber(value: string | number): boolean {
            return ((value != null) &&
                (value !== '') &&
                !isNaN(Number(value.toString())));
        }
    }

    private recordListPredefinedFiltersSelected = (): void => {
        // Reset the page
        this.resetPage();
        this.GetTreeData();
    }

    private recordListPageAmountSelected = (): void => {
        this.issueMaxNumberInList = $('#recordListPageAmount select').children("option:selected").val() as number; 
        this.GetTreeData();
    }

    private recordListSelectAllChecked = (): void => {
        const self = this;
        if ($('#recordListSelectAllBtn').is(":checked") == true) {
            self.treeView.treeview('checkAll', { silent: true });
        }
        else {
            self.treeView.treeview('uncheckAll', { silent: true });
        }
        self.checkVisibleButtons();
    }

    // ----------------------------------------------------------- //
    // CREATE/ADD TREE
    private createTree = (data: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#recordListTreeResults');
        self.treeView = tree.treeview({
            data: data,
            showCheckbox: true,
            multiSelect: false,
            onNodeSelected: function (event, node) {
                //if (node.WKT) {
                //    events.bus.publish(events.eventZoomToWKTandHighlight([[node.WKT], true, true]));
                //}
                //else {
                //    toastr.info('The record has no associated map feature')
                //}

                let data: ICAMSKey = { code: node.href, featureType: node.featureType };
                if (node.doNotOpenEditForm != true) {
                    events.bus.publish(events.eventOpenEditPanel(data));
                }
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = null; // Remove this temp settings

                self.treeView.treeview('uncheckAll', [{ silent: true }]);
                self.checkVisibleButtons(node);
                self.updateNumberCheckedMessage(); 
            },
            onNodeUnselected: function (event, node: INode) {
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage(); 
            },
            onNodeChecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('checkNode', [nodeIds, { silent: false }]);
                //}
                self.treeView.treeview('unselectAll', [{ silent: true }]);
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onNodeUnchecked: function (event, node) {
                //if (node.nodes != null) {
                //    let nodeIds = []; node.nodes.forEach(n => nodeIds.push(n.nodeId));
                //    self.treeView.treeview('uncheckNode', [nodeIds, { silent: false }]);
                //}
                self.checkVisibleButtons();
                self.updateNumberCheckedMessage();
            },
            onMapBtnClicked: function (event, node)
            {
                // Get the correct node instance from the tree and then fire the nodeSelected event
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = true; // temp set this to stop the edit form being opened
                self.treeView.treeview('selectNode', [nodeA, { silent: false }]);
                // ****************************************************************************** //

                if (node.wkt) {
                    events.bus.publish(events.eventZoomToWKTandHighlight([[node.wkt], true, true, node.featureType]));
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });

        // Create the tree header
        self.createTreeHeader();

        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }

        self.checkVisibleButtons();
        self.updateNumberCheckedMessage(); 
    }

    private addData_to_treeData = (input: Array<INode>): void => {
        const self = this;
        let featureType = parseInt($('#recordListTypeSelectOptions select').children("option:selected").val() as any);
        switch (featureType) {
            //case Default:
            //    add_withParentNode(FeatureType.MaintParent); count(FeatureType.MaintParent);
            //    add_withParentNode(FeatureType.InfraParent); count(FeatureType.InfraParent);
            //    add_withParentNode(FeatureType.RouteParent); count(FeatureType.RouteParent);
            //    add_withParentNode(FeatureType.LandParent); count(FeatureType.LandParent);

            //    break;
            case FeatureType.Route:
                add_noParentNode(FeatureType.RouteParent); count(FeatureType.RouteParent);
                break;
            case FeatureType.Maint:
                add_noParentNode(FeatureType.MaintParent); count(FeatureType.MaintParent);
                break;
            case FeatureType.Infra:
                add_noParentNode(FeatureType.InfraParent); count(FeatureType.InfraParent);
                break;
            case FeatureType.Land:
                add_noParentNode(FeatureType.LandParent); count(FeatureType.LandParent);
                break;
            case FeatureType.Path:
                add_noParentNode(FeatureType.PathParent); count(FeatureType.Path);
                break;
        }

        function add_noParentNode(featureType: FeatureType) {
            if (self.treeData == null) { self.treeData = []; }
            var inNode = input.find(f => f.featureType == featureType);
            if (inNode != null && inNode.nodes != null) {
                inNode.nodes.forEach(i => {
                    let index = self.treeData.findIndex(f => f.href == i.href);
                    if (index < 0) {
                        self.treeData.push(i); // Only add nodes if they are not already in the tree
                    }
                    else {
                        self.treeData[index] = i;
                    }
                });
            }
        }

        function add_withParentNode(featureType: FeatureType) {
            var inNode = input.find(f => f.featureType == featureType);
            if (inNode != null) {
                if (inNode.nodes != null && inNode.nodes.length > 0) {
                    if (self.treeData.find(f => f.featureType == featureType) == null) {
                        self.treeData.push(inNode);
                    }
                    else {
                        inNode.nodes.forEach(i => {
                            let n = self.treeData.find(f => f.featureType == featureType);
                            if (n != null) {
                                if (n.nodes == null) { n.nodes = []; }
                                if (n.nodes.findIndex(x => x.href == i.href) < 0) {
                                    n.nodes.push(i); // Only add nodes if they are not already in the tree
                                }
                            }
                        });
                    }
                }
            }
        }

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }

    private removeData_from_treeData = (data: ICAMSKey): void => {
        const self = this;

        self.treeData.forEach(p => {
            if (p.nodes != null) {
                let index = p.nodes.findIndex(n => n.featureType == data.featureType && n.href == data.code);
                if (index >= 0) {
                    p.nodes.splice(index, 1);
                    p.count = p.nodes.length;
                }
            }
        });
    }

    private DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
    }

    private ExpandAllNodes = (): void => {
        this.treeView.treeview('expandAll', { silent: true });
    }

    private CollapseAllNodes = (): void => {
        this.treeView.treeview('collapseAll', { silent: true });
    }

    private SelectAllNodes = (): void => {
        this.treeView.treeview('collapseAll', { silent: true });
    }

    private UnSelectAllNodes = (): void => {
        this.treeView.treeview('collapseAll', { silent: true });
    }

    private ZoomToChecked = (): void => {
        const self = this;
        var nodes: Array<INode> = self.treeView.treeview('getChecked');
        nodes.push(self.treeView.treeview('getSelected'));

        var wktArr = []; var featureType;
        nodes.forEach(n => {
            if (n.wkt != null) {
                wktArr.push(n.wkt);
                featureType = n.featureType;
            }
        });
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, featureType]));
    }

    private updateNumberCheckedMessage = (): void => {
        let num = this.treeView.treeview('getChecked').length;
        let s = num > 1 ? "s" : "";
        Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "RecordList_ItemsSelectedLabel" }]).then(m => {
            let label = "items selected";
            if (m.success == true) label = m.data[0].value;

            if (num == 0) {
                $('#recordListNumberCheckedBtn').hide();
            }
            else {
                $('#recordListNumberCheckedBtn').html(`${num} ${label}`);
                $('#recordListNumberCheckedBtn').show();
            }
        });
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;

        var lang = window.isSiteInWelsh() == true ? 1 : 0;
        
        // Add the header to issues only
        let featureType = parseInt($('#recordListTypeSelectOptions select').children("option:selected").val() as any);
        var colDef;
        if (featureType == FeatureType.Maint) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: IssueOrder.MaintCode, size: 2 },
                { label: Translations.Lang.Logged[lang], value: IssueOrder.LogDate, size: 2 },
                { label: Translations.Lang.Type[lang], value: IssueOrder.Type, size: 4 },
                { label: Translations.Lang.Priority[lang], value: IssueOrder.Priority, size: 2 },
                { label: Translations.Lang.Status[lang], value: IssueOrder.StatusDescr, size: 2 }
            ];
            
        }
        else if (featureType == FeatureType.Infra) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: InfraOrder.InfraCode, size: 2 },
                { label: Translations.Lang.Logged[lang], value: null, size: 2 },
                { label: Translations.Lang.Type[lang], value: InfraOrder.InfraTypeDescr, size: 6 },
                { label: Translations.Lang.Status[lang], value: null, size: 2 }
            ];
        }
        else if (featureType == FeatureType.Path) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: PathOrder.RouteCode, size: 2 },
                { label: Translations.Lang.Status[lang], value: PathOrder.StatusDescr, size: 2 },
                { label: Translations.Lang.LegalType[lang], value: PathOrder.LegalTypeDescr, size: 2 },
                { label: Translations.Lang.Parish[lang], value: PathOrder.AdminAreaDescr, size: 4 },
                { label: Translations.Lang.Priority[lang], value: PathOrder.PriorityDescr, size: 2 }
            ]; 
        }
        else if (featureType == FeatureType.Route) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: RouteOrder.RouteCode, size: 2 },
                { label: Translations.Lang.Status[lang], value: RouteOrder.Status, size: 2 },
                { label: Translations.Lang.LegalType[lang], value: RouteOrder.LegalType, size: 3 },
                { label: Translations.Lang.Parish[lang], value: RouteOrder.AdminArea, size: 3 },
                { label: Translations.Lang.Priority[lang], value: RouteOrder.Priority, size: 2 }
            ];
        }
        else if (featureType == FeatureType.Land) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: LandOrder.LandCode, size: 2 },
                { label: Translations.Lang.Reference[lang], value: LandOrder.ClientRef, size: 5 },
                { label: Translations.Lang.Use[lang], value: LandOrder.LanduseDescr, size: 3 },
                { label: Translations.Lang.Area[lang], value: LandOrder.Area, size: 2 }
            ];
        }

        // Create the header
        self.treeView.treeview('addHeader', {
            cols: colDef,
            currentSortDirection: self.currentSortDirection,
            currentSortOrder: self.currentSortOrder,
            callback: function (order, dir) {
                self.currentSortOrder = order;
                self.currentSortDirection = dir;
                self.GetTreeData();
            }
        });

    }

    // ----------------------------------------------------------- //
    // BTN ACTIONS
    private checkVisibleButtons = (selectedNode: INode = null): void => {
        const self = this;
        let nodes: Array<INode> = self.treeView.treeview('getChecked');
        if (selectedNode != null && nodes.length == 0) nodes.push(selectedNode); // Add the selected node to the list if it is not null

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => {
            self.actionBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the node type
        // If the row was just selected then also turn on the buttons
        if (nodes && nodes.length > 0) {
            if (self.authModel.enableTasksOnIssuesOnly == true) {
                if (nodes[0].featureType == FeatureType.Maint) {
                    self.actionBtns.newTask.enable = true;
                }
            }
            else {
                if (nodes[0].featureType == FeatureType.Maint || nodes[0].featureType == FeatureType.Route || nodes[0].featureType == FeatureType.Land || nodes[0].featureType == FeatureType.Infra) {
                    self.actionBtns.newTask.enable = true;
                }
            }
            self.actionBtns.viewprint.enable = true; // Enable print if 1 or more records is selected
        }

        // Enable print, if the filter.viewName is available
        let filterDef: IFilterDefinitionModel = $('#recordListPredefinedFiltersOptions select').children("option:selected").data('filterdefinition');
        if (filterDef != null && filterDef.viewName != null) self.actionBtns.viewprint.enable = true;

        if (nodes && nodes.length == 1) {
            self.actionBtns.map.enable = true;
            self.actionBtns.export.enable = true
            self.actionBtns.annotate.enable = true;
            self.actionBtns.edit.enable = true;
            self.actionBtns.query.enable = true;
        }
        else if (nodes && nodes.length > 1) {
            self.actionBtns.map.enable = true;
            self.actionBtns.export.enable = true;
        }

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    private updatePagingUI = (): void => {
        const self = this;
        if (self.issueCountFromServer > 0) {
            $('#recordCount').html(' (' + self.issueCountFromServer + ')');
        }
        else {
            $('#recordCount').html();
        }
        var pages = Math.ceil(self.issueCountFromServer / self.issueMaxNumberInList);
        if (pages == 0) pages = 1;
        if (self.currentPage > pages) { self.currentPage = pages };

        $('#recordListShowing').html((self.currentPage + 1).toString() + " " + self.RecordList_Label_Of+" " + pages);
    }

    private resetPage = (): void => {
        // Reset the page
        this.currentPage = 0;
        this.issueCountFromServer = 0;

        // Remove all custom filters and add a blank one
        this.currentSortDirection = null;
        this.currentSortOrder = null;

        // Check if there are custom filters configured
        $('#recordListCustomFilterContainer [name="recordListCustomFilterRow"]').remove();
        $('#recordListPredefinedFiltersOptions select').removeAttr("disabled");
        //$('#recordListTitle').text("Record list");
        var tree: any = $('#recordListTreeResults');
        this.treeData = [];
        this.treeView = tree.treeview();
        this.issueCountFromServer = 0;
        this.updatePagingUI();
    }

    public GetRecordSelectRecords = (callback: Function): void => {
        var result = [];
        if (this.treeView != undefined) result = this.treeView.treeview('getChecked')
        callback(result);
    }

    public reRunLastInfoRequest = (): void => {
        const self = this;
        self.GetTreeData();
    }

    private getPredefinedFilterIndexOfCustomFilter = (): number => {
        var i = -1; var counter = 0;

        $("#recordListPredefinedFiltersOptions select option").each(function () {
            var data: IFilterDefinitionModel = $(this).data('filterdefinition');
            if (data && data.customFilter && data.customFilter == true) {
                i = counter;
            }
            counter++;
        });
        return i;
    }
    
}